import { Routes } from "@angular/router";
import { ChannelListComponent } from "./channel-list/channel-list.component";
import { CreateChannelComponent } from "./create-channel/create-channel.component";

export const channelsRoutes: Routes = [
    {
        path: '',
        component: ChannelListComponent
    },
    {
        path: 'create',
        component: CreateChannelComponent
    }
];